$(function () {
    $('#Withdraw input[name="agreement"]').change(function() {
        monitoringAgreement();
    });
    monitoringAgreement();
});

// 同意ボタンのチェック有無で送信ボタンを有効にする
function monitoringAgreement () {
    if ($('#Withdraw input[name="agreement"]').is(':checked')) {
        $('#Withdraw input[type="submit"]').prop('disabled', false);
    } else {
        $('#Withdraw input[type="submit"]').prop('disabled', true);
    }
}
